import { combineReducers } from 'redux'
import ArrayUtil from '@leverege/array-util'

import { GeotileActions, Constants } from '~/actions/'

const initialGeotilesState = {
  geotiles : [],
  status : null
};

function geotiles( state = initialGeotilesState, action ) {

  switch ( action.type ) {

    case GeotileActions.ADD_GEOTILE: { 
      const nGeotiles = [].concat( state.geotiles )
      nGeotiles.push( action.geotile )
      return { geotiles : nGeotiles, status : null }
    }

    case GeotileActions.GET_GEOTILES: 
      return { geotiles : action.geotiles, status : null }
    
    case GeotileActions.REMOVE_GEOTILE: {
      const nGeotiles = state.geotiles.filter( geotile => geotile.id !== action.geotileId )
      return { geotiles : nGeotiles, status : null }
    }

    case GeotileActions.LOADING_GEOTILES: {
      return { ...state, status : 'loading' }
    }

    case GeotileActions.UPDATE_GEOTILE: {
      const nState = { ...state }
      nState.geotiles = [].concat( state.geotiles )
      const index = ArrayUtil.replace( nState.geotiles, 'id', action.geotile.id, action.geotile )
      return nState
    }
    
    default:
      return state

  }
}

module.exports = geotiles
